<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <div class="search-name">供应商</div>
                    <el-select
                        class="search-item"
                        size="small"
                        v-model="searchData.EntpCusName"
                        remote
                        filterable
                        allow-create
                        placeholder="请输入供应商名称"
                        :remote-method="searchSupplier"
                        v-select-scroll-more="searchSupplierLoad"
                    >
                        <el-option v-for="item in supplierOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName"> </el-option>
                    </el-select>
                    <div class="search-name">退货单号</div>
                    <el-input
                        class="search-item"
                        size="small"
                        v-model.trim="searchData.ReturnCode"
                        v-filter-special-char="searchData.ReturnCode"
                        placeholder="请输入退货单号"
                    ></el-input>
                    <div class="search-name">采购单号</div>
                    <el-input
                        class="search-item"
                        size="small"
                        v-model.trim="searchData.OrderCode"
                        v-filter-special-char="searchData.OrderCode"
                        placeholder="请输入采购单号"
                    ></el-input>
                    <div class="search-name">退款方式</div>
                    <el-select class="search-item" size="small" v-model="searchData.PayType" multiple collapse-tags clearable>
                        <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                    </el-select>
                    <div class="search-name">退款状态</div>
                    <el-select class="search-item" size="small" v-model="searchData.RState">
                        <el-option v-for="item in returnStateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                    </el-select>
                    <div class="search-name">物流状态</div>
                    <el-select class="search-item" size="small" v-model="searchData.DeliveryStat">
                        <el-option v-for="item in deliveryStateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                    </el-select>
                    <div class="search-name">采购员</div>
                    <el-select v-model="searchData.SId" class="search-item" size="small" filterable clearable placeholder="请选择">
                        <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                    </el-select>
                    <div class="search-name">创建时间</div>
                    <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    <el-button v-if="permission.print" size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="print()">{{ permission.print }}</el-button>
                    <el-button size="small" icon="el-icon-s-data" class="search-btn btn-primary" @click="showCount">合计</el-button>
                </div>
            </div>
            <div>
                <el-card class="box-card">
                    <div class="data-count">
                        <div class="data-item">
                            <p>采购总额</p>
                            <p>￥{{ statData.supTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>退货商品总数</p>
                            <p>{{ statData.returnCount }}</p>
                        </div>
                        <div class="data-item">
                            <p>退款总额</p>
                            <p style="color: red; font-size: 16px">￥{{ statData.returnTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>已退总计</p>
                            <p>￥{{ statData.refundTotal }}</p>
                        </div>
                        <div class="data-item border-right-none">
                            <p>待收退款总计</p>
                            <p style="color: green; font-size: 16px">￥{{ statData.surplusTotal }}</p>
                        </div>
                    </div>
                </el-card>
            </div>
            <div class="table-ctn purreturngather-table">
                <el-table
                    border
                    :header-cell-style="{ background: '#F2F6FC' }"
                    @selection-change="handleSelectionChange"
                    ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%; cursor: pointer"
                    highlight-current-row
                    @cell-dblclick="handleDBClick"
                    :tableCode="tableCode"
                    :row-key="getRowKeys"
                >
                    <el-table-column type="selection" reserve-selection width="55"></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.ReturnCode.IsShow"
                        :width="columnShowSets.ReturnCode.Width > 0 ? columnShowSets.ReturnCode.Width + 'px' : '220px'"
                        :label="columnShowSets.ReturnCode.ColumnName"
                        prop="ReturnCode"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <el-badge :value="scope.row.ApplyCount + '条待确认'" class="mark" type="danger" v-if="scope.row.ApplyCount > 0">
                                {{ scope.row.ReturnCode }}
                            </el-badge>
                            {{ scope.row.ApplyCount > 0 ? '' : scope.row.ReturnCode }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="columnShowSets.OrderCode.IsShow"
                        :width="columnShowSets.OrderCode.Width > 0 ? columnShowSets.OrderCode.Width + 'px' : '170px'"
                        :label="columnShowSets.OrderCode.ColumnName"
                        prop="OrderCode"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <!-- <el-button @click.native.stop="gotoPurDetails(scope.row)" type="text">{{ scope.row.OrderCode }}</el-button> -->
                            <el-button @click.native.stop="copyCode(scope.row)" title="单击单号复制，双击查看详情" type="text">{{ scope.row.OrderCode }}</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="columnShowSets.EntpCusName.IsShow"
                        :min-width="columnShowSets.EntpCusName.Width > 0 ? columnShowSets.EntpCusName.Width + 'px' : '200px'"
                        :label="columnShowSets.EntpCusName.ColumnName"
                        prop="EntpCusName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="SurplusMoney"
                        v-if="columnShowSets.SurplusMoney.IsShow"
                        :min-width="columnShowSets.SurplusMoney.Width > 0 ? columnShowSets.SurplusMoney.Width + 'px' : '100px'"
                        :label="columnShowSets.SurplusMoney.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="ReturnMoney"
                        v-if="columnShowSets.ReturnMoney.IsShow"
                        :min-width="columnShowSets.ReturnMoney.Width > 0 ? columnShowSets.ReturnMoney.Width + 'px' : '100px'"
                        :label="columnShowSets.ReturnMoney.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="ReturnCount"
                        v-if="columnShowSets.ReturnCount.IsShow"
                        :min-width="columnShowSets.ReturnCount.Width > 0 ? columnShowSets.ReturnCount.Width + 'px' : '100px'"
                        :label="columnShowSets.ReturnCount.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="PayTypeName"
                        v-if="columnShowSets.PayTypeName.IsShow"
                        :min-width="columnShowSets.PayTypeName.Width > 0 ? columnShowSets.PayTypeName.Width + 'px' : '100px'"
                        :label="columnShowSets.PayTypeName.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.RefundStateName.IsShow"
                        :width="columnShowSets.RefundStateName.Width > 0 ? columnShowSets.RefundStateName.Width + 'px' : '100px'"
                        :label="columnShowSets.RefundStateName.ColumnName"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <i v-if="scope.row.RefundStateName == '已完成退款'" class="c-active">{{ scope.row.RefundStateName }}</i>
                            <i v-else>{{ scope.row.RefundStateName }}</i></template
                        ></el-table-column
                    >
                    <el-table-column
                        prop="Refund"
                        v-if="columnShowSets.Refund.IsShow"
                        :min-width="columnShowSets.Refund.Width > 0 ? columnShowSets.Refund.Width + 'px' : '100px'"
                        :label="columnShowSets.Refund.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.OutWarehouseStateName.IsShow"
                        :width="columnShowSets.OutWarehouseStateName.Width > 0 ? columnShowSets.OutWarehouseStateName.Width + 'px' : '100px'"
                        :label="columnShowSets.OutWarehouseStateName.ColumnName"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <i v-if="scope.row.OutWarehouseStateName == '已出仓'" class="out-active">{{ scope.row.OutWarehouseStateName }}</i>
                            <i v-else>{{ scope.row.OutWarehouseStateName }}</i></template
                        >
                    </el-table-column>
                    <el-table-column
                        prop="SName"
                        v-if="columnShowSets.SName.IsShow"
                        :min-width="columnShowSets.SName.Width > 0 ? columnShowSets.SName.Width + 'px' : '80px'"
                        :label="columnShowSets.SName.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="ReturnTime"
                        sortable
                        v-if="columnShowSets.ReturnTime.IsShow"
                        :min-width="columnShowSets.ReturnTime.Width > 0 ? columnShowSets.ReturnTime.Width + 'px' : '160px'"
                        :label="columnShowSets.ReturnTime.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="Creator"
                        v-if="columnShowSets.Creator.IsShow"
                        :min-width="columnShowSets.Creator.Width > 0 ? columnShowSets.Creator.Width + 'px' : '80px'"
                        :label="columnShowSets.Creator.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="CreateTime"
                        sortable
                        v-if="columnShowSets.CreateTime.IsShow"
                        :min-width="columnShowSets.CreateTime.Width > 0 ? columnShowSets.CreateTime.Width + 'px' : '160px'"
                        :label="columnShowSets.CreateTime.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column label="操作" fixed="right" :autoWidth="true" :isCanSet="true">
                        <template slot-scope="scope">
                            <el-button
                                v-if="permission.purchasesReturnsGatheringFunc && scope.row.IsCanRefund"
                                @click="gotoDetails('creceipt', scope.row)"
                                type="text"
                                size="small"
                                >{{ permission.purchasesReturnsGatheringFunc }}</el-button
                            >
                            <el-button v-else-if="permission.editAndConfirm && scope.row.IsCanRefund" @click="gotoDetails('creceipt', scope.row)" type="text" size="small">{{
                                permission.editAndConfirm
                            }}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                    v-if="tableDataLength != 0"
                ></el-pagination>
            </div>
            <el-dialog :close-on-click-modal="false" title="合计" @close="closeDialog" :visible.sync="statisticsVisible" width="500px">
                <div class="dialog-content" v-if="statisticsVisible">
                    <statistics :countData="multipleSelection" type="buyReturn"></statistics>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="创建时间" :visible.sync="timeVisible" width="800px">
                <div class="dialog-content" v-if="timeVisible">
                    <timePicker @timerSearch="timerSearch" :start="this.searchData.StartDate" :end="this.searchData.EndDate"></timePicker>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="dialogVisible" width="1000px">
                <div class="dialog-content" v-if="dialogVisible">
                    <printContent @closeDialog="closeDialog" :printIds="multipleSelection"></printContent>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import Vue from 'vue';
import statistics from '@/components/common/statistics.vue';
import timePicker from '@/components/common/timePicker';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import { constants } from 'zlib';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {
        statistics,
        timePicker,
        breadcrumb,
        elTableColumn
    },
    props: ['type'],
    data() {
        return {
            tableCode: 'PurReturnGathering',
            dialogVisible: false,
            timeVisible: false,
            statisticsVisible: false,
            multipleSelection: null,
            tableData: [],
            options: [],
            searchData: {
                RState: '5',
                PayType: [],
                EntpCusName: '',
                ReturnCode: '',
                OrderCode: '',
                StartDate: '',
                DeliveryStat: '',
                EndDate: '',
                Source: '1',
                page: 1, // 当前页数
                limit: 15 // 每页限制条数
            },
            statData: {
                returnTotal: 0,
                supTotal: 0,
                refundTotal: 0,
                returnCount: 0,
                surplusTotal: 0
            },
            tableDataLength: 0,
            permission: {},
            dialogFormVisible: false,
            reasonFormData: {},
            returnStateList: [
                { Text: '全部', Value: '' },
                { Text: '未退款', Value: '5' },
                { Text: '已退定金', Value: '10' },
                { Text: '已完成退款', Value: '15' }
            ],
            deliveryStateList: [
                { Text: '全部', Value: '' },
                { Text: '未出仓', Value: '5' },
                { Text: '部分出仓', Value: '10' },
                { Text: '已出仓', Value: '15' },
                { Text: '不需出仓', Value: '20' }
            ],
            payWayList: [],
            SIdList: [],
            columnShowSets: {
                OrderCode: { ColumnName: '', IsShow: false, Width: 0 },
                EntpCusName: { ColumnName: '', IsShow: false, Width: 0 },
                ReturnCode: { ColumnName: '', IsShow: false, Width: 0 },
                SurplusMoney: { ColumnName: '', IsShow: false, Width: 0 },
                ReturnMoney: { ColumnName: '', IsShow: false, Width: 0 },
                ReturnCount: { ColumnName: '', IsShow: false, Width: 0 },
                PayTypeName: { ColumnName: '', IsShow: false, Width: 0 },
                RefundStateName: { ColumnName: '', IsShow: false, Width: 0 },
                Refund: { ColumnName: '', IsShow: false, Width: 0 },
                ReturnTime: { ColumnName: '', IsShow: false, Width: 0 },
                OutWarehouseStateName: { ColumnName: '', IsShow: false, Width: 0 },
                Creator: { ColumnName: '', IsShow: false, Width: 0 },
                SName: { ColumnName: '', IsShow: false, Width: 0 },
                CreateTime: { ColumnName: '', IsShow: false, Width: 0 }
            },
            // 用于供应商列表，分页搜索
            supplierOptions: [],
            supplierForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
             clickTimer: null,  //添加一个计时器
        };
    },
    created() {
        if (this.tableCode) this.getSetsData();
    },
    mounted() {
        this.initSearchSelectData();
        this.getTableData();
        this.searchSupplier();
        this.permission = this.$util.getPermission('purchasesReturnsGathering');
        this.$util.setEnterEvent(this, this.$route.fullPath);

        let that = this;
        Vue.component('printContent', function (resolve) {
            that.$util.getPrintComponents(5).then(data => {
                if (data) {
                    require(['@/components/printModels/' + data], resolve);
                } else {
                    require(['@/components/printModels/printPurReturn'], resolve);
                }
            });
        });
    },
    watch: {
        NeedRefresh(value) {
            if (value) {
                this.getTableData();
                this.$store.commit('updateNeedRefresh', false);
            }
        }
    },
    computed: {
        NeedRefresh() {
            return this.$store.state.needRefresh;
        }
    },
    methods: {
        // 记录每行的key值
        getRowKeys(row) {
            return row.PReturnId;
        },
        // 供应商列表，搜索
        async searchSupplier(key) {
            if (![undefined].includes(key)) {
                this.supplierForm.Page = 1;
                this.supplierForm.stopLoad = false;
                this.supplierForm.key = key;
                this.supplierOptions = [];
            }
            if (this.supplierForm.stopLoad) return;
            const data = await this.$util.searchSupplier(this.supplierForm.key, this.supplierForm.Page, this.supplierForm.Limit);
            if (data) {
                if (!data) return;
                this.supplierForm.stopLoad = data.length < this.supplierForm.Limit;
                this.supplierOptions = [...this.supplierOptions, ...data];
            }
        },
        // 供应商列表，加载更多
        searchSupplierLoad() {
            this.supplierForm.Page += 1;
            this.searchSupplier();
        },
        initSearchSelectData() {
            //可以把这些常用的数据放到缓存里面
            this.getPay();
            this.getSIdList();
        },
        getSIdList() {
            this.$util.getSIdList().then(data => {
                this.SIdList = data;
            });
        },
        //  结算方式
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        // 显示统计
        showCount() {
            if (this.multipleSelection) {
                this.statisticsVisible = true;
            } else {
                this.$util.warningMsg('请至少选择一条数据');
            }
        },
        closeDialog() {
            this.$refs.multipleTable.clearSelection();
            this.multipleSelection = null;
            this.statisticsVisible = false;
            this.dialogVisible = false;
        },
        // 勾选统计
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 跳转到关联采购单
        gotoPurDetails(row) {
            this.$router.push(`/purchaseManage/purchaseOrders/edit_v2?type=1&id=${row.EntpCusPOId}&fromLv2=revenue_r`);
        },
        // 跳转订单详情
        gotoDetails(type, item) {
            let PReturnId = item ? item.PReturnId : '';
            let EntpCusPOId = item ? item.EntpCusPOId : '';
            this.$router.push(`/financeManage/purchasesReturns/gathering/confirmPurchasesRefunds?action=${type}&PReturnId=${PReturnId}&id=${EntpCusPOId}`);
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosPost({
                    url: '/api/RevenueManagement/GetPurchaseReturnsList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = {};
                    this.statData.returnTotal = data.ReturnTotal;
                    this.statData.supTotal = data.SupTotal;
                    this.statData.refundTotal = data.RefundTotal;
                    this.statData.returnCount = data.ReturnCount;
                    this.statData.surplusTotal = data.SurplusTotal;
                    this.tableData = data.ReturnOrderList;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        resetSearch() {
            this.searchData = {
                RState: '5',
                PayType: [],
                EntpCusName: '',
                ReturnCode: '',
                OrderCode: '',
                DeliveryStat: '',
                StartDate: '',
                EndDate: '',
                Source: '1',
                page: 1, // 当前页数
                limit: this.commonPageSize // 每页限制条数
            };
            this.searchSupplier('');
            this.$refs.multipleTable.clearSelection();
        },
        handleSearch() {
            this.$refs.multipleTable.clearSelection();
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(row, column, cell, event) {
            clearTimeout(this.clickTimer); //清除未执行的定时器
            if (row) {
                if(column.property == "OrderCode"&&row.OrderCode){
                    this.gotoPurDetails(row)
                }
                else
                    this.gotoDetails('see', row);
            }
            event.stopPropagation()
        },
        // 打印
        print() {
            let listArr = this.multipleSelection;
            if (listArr.length !== 1) {
                this.$util.warningMsg('请选择一张采购退货单打印');
                return;
            }
            this.dialogVisible = true;
        },
        getSetsData() {
            this.$util.getTableSetsData(this.tableCode, true).then(data => {
                data.forEach(item => {
                    switch (item.ColumnCode) {
                        case 'OrderCode':
                            this.columnShowSets.OrderCode.IsShow = item.IsShow;
                            this.columnShowSets.OrderCode.Width = item.Width;
                            this.columnShowSets.OrderCode.ColumnName = item.ColumnName;
                            break;
                        case 'EntpCusName':
                            this.columnShowSets.EntpCusName.IsShow = item.IsShow;
                            this.columnShowSets.EntpCusName.Width = item.Width;
                            this.columnShowSets.EntpCusName.ColumnName = item.ColumnName;
                            break;
                        case 'SurplusMoney':
                            this.columnShowSets.SurplusMoney.IsShow = item.IsShow;
                            this.columnShowSets.SurplusMoney.Width = item.Width;
                            this.columnShowSets.SurplusMoney.ColumnName = item.ColumnName;
                            break;
                        case 'ReturnCode':
                            this.columnShowSets.ReturnCode.IsShow = item.IsShow;
                            this.columnShowSets.ReturnCode.Width = item.Width;
                            this.columnShowSets.ReturnCode.ColumnName = item.ColumnName;
                            break;
                        case 'PayTypeName':
                            this.columnShowSets.PayTypeName.IsShow = item.IsShow;
                            this.columnShowSets.PayTypeName.Width = item.Width;
                            this.columnShowSets.PayTypeName.ColumnName = item.ColumnName;
                            break;
                        case 'ReturnMoney':
                            this.columnShowSets.ReturnMoney.IsShow = item.IsShow;
                            this.columnShowSets.ReturnMoney.Width = item.Width;
                            this.columnShowSets.ReturnMoney.ColumnName = item.ColumnName;
                            break;
                        case 'ReturnCount':
                            this.columnShowSets.ReturnCount.IsShow = item.IsShow;
                            this.columnShowSets.ReturnCount.Width = item.Width;
                            this.columnShowSets.ReturnCount.ColumnName = item.ColumnName;
                            break;
                        case 'OutWarehouseStateName':
                            this.columnShowSets.OutWarehouseStateName.IsShow = item.IsShow;
                            this.columnShowSets.OutWarehouseStateName.Width = item.Width;
                            this.columnShowSets.OutWarehouseStateName.ColumnName = item.ColumnName;
                            break;
                        case 'RefundStateName':
                            this.columnShowSets.RefundStateName.IsShow = item.IsShow;
                            this.columnShowSets.RefundStateName.Width = item.Width;
                            this.columnShowSets.RefundStateName.ColumnName = item.ColumnName;
                            break;
                        case 'Refund':
                            this.columnShowSets.Refund.IsShow = item.IsShow;
                            this.columnShowSets.Refund.Width = item.Width;
                            this.columnShowSets.Refund.ColumnName = item.ColumnName;
                            break;
                        case 'ReturnTime':
                            this.columnShowSets.ReturnTime.IsShow = item.IsShow;
                            this.columnShowSets.ReturnTime.Width = item.Width;
                            this.columnShowSets.ReturnTime.ColumnName = item.ColumnName;
                            break;
                        case 'Creator':
                            this.columnShowSets.Creator.IsShow = item.IsShow;
                            this.columnShowSets.Creator.Width = item.Width;
                            this.columnShowSets.Creator.ColumnName = item.ColumnName;
                            break;
                        case 'SName':
                            this.columnShowSets.SName.IsShow = item.IsShow;
                            this.columnShowSets.SName.Width = item.Width;
                            this.columnShowSets.SName.ColumnName = item.ColumnName;
                            break;
                        case 'CreateTime':
                            this.columnShowSets.CreateTime.IsShow = item.IsShow;
                            this.columnShowSets.CreateTime.Width = item.Width;
                            this.columnShowSets.CreateTime.ColumnName = item.ColumnName;
                            break;
                    }
                });
            });
        },
        copyCode(row){
            let that=this;
            clearTimeout(that.clickTimer); //清除未执行的定时器
            that.clickTimer = setTimeout(function () {
                let inputNode = document.createElement('input')  // 创建input
                inputNode.value = row.OrderCode // 赋值给 input 值
                document.body.appendChild(inputNode) // 插入进去
                inputNode.select() // 选择对象
                document.execCommand('Copy') // 原生调用执行浏览器复制命令
                inputNode.className = 'oInput'
                inputNode.style.display = 'none' // 隐藏
                that.$message.success('复制成功')
            }, 500);
        },     
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 20%;
        border-right: 1px solid @border4Color;
        > p:nth-child(1) {
            margin-bottom: 5px;
        }
    }
}
</style>
<style lang="less">
.purreturngather-table {
    .el-table__row {
        td:nth-child(2) {
            .cell {
                overflow: visible;
            }
        }
    }
}
</style>
